import ExpirationMessage from './ExpirationMessage';

export type { ExpirationMessageProps } from './types';
export default ExpirationMessage;
